
function setValue(field, value) {
    let fieldEls = document.querySelectorAll("[name='" + field + "']:not([type=hidden])");

    if (fieldEls.length === 0){
        fieldEls = document.querySelectorAll("[name='_" + field + "']:not([type=hidden])");
    }

    fieldEls.forEach(function(fieldEl) {
        console.log("setValue", field, value, fieldEl);

        if (!fieldEl) return;

        switch (fieldEl.type || fieldEl.tagName) {
            case 'checkbox':
                if (!Array.isArray(value)) {
                    value = [value];
                }

                let checkboxEl;

                value.forEach(checkboxValue => {
                    if (checkboxEl = document.querySelector("input[type=checkbox][value='" + checkboxValue + "']")) {
                        checkboxEl.checked = true;
                    }
                });
                break;

            case 'radio':
                document.querySelector("input[type=radio][value='" + value + "']").checked = true;
                break;

            case 'textarea':
                fieldEl.value = value;
                fieldEl.style = 'display:none;';
                break;

            default:
                fieldEl.value = value;
                fieldEl.type = 'hidden';
                break;
        }
    });
}

export default function fillFormFields(params) {
    let fieldKey, fieldValue, field, group;

    console.log('fillFormFields', params);

    Object.entries(params).forEach(entry => {
        [fieldKey, fieldValue] = entry;
        field = fieldKey;

        console.log('fillFormField: ', fieldKey, fieldValue);

        if (field.indexOf("invitee_") >= 0) {
            field = field.replace("invitee_", "");

            if (field === "full_name") {
                field = "first_name";
            }
        }

        if (Array.isArray(fieldValue)) {
            field = field + '[]';
        }

        console.log('setValueBEF: ', field, fieldValue);

        setValue(field, fieldValue);

        group = document.getElementById(field + "-group");

        if (group) {
            group.style = "display: none;";
        }
    });
}


// WEBPACK FOOTER //
// ./app/Modules/FormBuilder/resources/assets/js/fill-form-fields.js